var map = {
	"./busd.svg": 2078,
	"./crypto-pending.png": 2079,
	"./crypto-reject.png": 2080,
	"./crypto-success.png": 2081,
	"./direpay.svg": 2082,
	"./trx.svg": 2083,
	"./usdc.svg": 2084,
	"./usdt.svg": 2085
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;